import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import { Divider, Grid, Popup, Button, Label } from 'semantic-ui-react'

const PlaceName = styled.div`
  font-weight: bold;
  font-size: 15;
`

const ButtonWrapper = styled.div`
  text-align: center;
`

const STATUS_COLORS = { delivered: 'green', rejected: 'red', pending: 'yellow' }
class LocationCell extends React.PureComponent {
  state = { visible: false }

  showOrderMap = () => {
    const { pickUp, receivers } = this.props
    const multipleDestination = receivers
      .map(receiver => [receiver.latitude, receiver.longitude].join(','))
      .join('/')
    const maps = `https://www.google.com/maps/dir/${pickUp.latitude},${
      pickUp.longitude
    }/${multipleDestination}`

    this.setState({ visible: false })

    window.open(maps)
  }

  renderOrderReceiverListing = receivers => {
    const receiversLength = receivers.length
    return receivers.map(receiver => {
      const {
        key,
        place_name: placeName = 'Unknown',
        order_number: orderNumber = '---',
        status,
        distance,
        collect_payment: collectPayment,
      } = receiver
      const distanceInKm = distance ? `${parseFloat(distance / 1000).toFixed(2)} km` : '---'
      return (
        <div key={key}>
          {orderNumber} - {placeName}
          <br />
          Distance: {distanceInKm}
          <br />
          Collect Payment: {collectPayment || 0}
          <br />
          Status:{' '}
          <Label color={STATUS_COLORS[status]} size="small">
            {_.capitalize(status)}
          </Label>
          {orderNumber !== receiversLength && <Divider style={{ width: '50%', margin: '14px auto' }} />}
        </div>
      )
    })
  }

  render() {
    const { visible } = this.state
    const { distance, pickUp, receivers } = this.props
    const multipleReceiverInfo = receivers.length > 1 ? `(${receivers.length})` : ''
    return (
      <Popup
        trigger={
          <Button
            color="orange"
            content={`${parseFloat(distance / 1000).toFixed(2)} km ${multipleReceiverInfo}`}
            icon="map"
            size="mini"
            labelPosition="right"
            style={{ margin: 0, width: 120, marginTop: 5 }}
          />
        }
        flowing
        on="click"
        position="right center"
        open={visible}
        onOpen={() => this.setState({ visible: true })}
        onClose={() => this.setState({ visible: false })}
      >
        <div>
          <div>
            <Grid.Row textAlign="center">
              <PlaceName>Pick-up:</PlaceName>
              <p>{` ${_.get(pickUp, 'place_name', 'Unknown')}`}</p>
            </Grid.Row>
          </div>
          <Divider />
          <div >
            <Grid.Row textAlign="center hide-scrollbar" style={{overflowY: 'auto', maxHeight: 400}}>
              <PlaceName>Drop-off:</PlaceName>
              {this.renderOrderReceiverListing(receivers)}
            </Grid.Row>
          </div>
          <Divider />
        </div>
        <ButtonWrapper>
          <Button size="mini" onClick={this.showOrderMap}>
            Show Order Map
          </Button>
        </ButtonWrapper>
      </Popup>
    )
  }
}

export default LocationCell



// WEBPACK FOOTER //
// ./src/containers/express/components/LocationCell.js